import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'

import { selectGetSelectedProgramId } from '@/features/programs/stores/programs/programs.selectors'
import programsStore from '@/features/programs/stores/programs/programs.store'
import { getWhiteLabelData, WHITE_LABEL_QUERY_KEY } from '@/features/ui/api/global-data'
import type { V1WhiteLabelDataType, V2WhiteLabelDataType } from '@/types/global-data'

function V1ToV2DataMiddleware(data?: V1WhiteLabelDataType): Partial<V2WhiteLabelDataType> {
  return {
    logo: data?.setting.find((item) => item.name === 'LOGO')?.value,
    logoSmall: data?.setting.find((item) => item.name === 'LOGO_SMALL')?.value,
    logoSSO: data?.setting.find((item) => item.name === 'LOGO_SSO')?.value,
    favIcon: data?.setting.find((item) => item.name === 'FAVICON')?.value,
    colorPrimary: data?.setting.find((item) => item.name === 'COLOR_PRIMARY')?.value,
    colorSecondary: data?.setting.find((item) => item.name === 'COLOR_SECONDARY')?.value,
    customStyle: data?.setting.find((item) => item.name === 'CUSTOM_STYLE')?.value,
    companyTitle: data?.setting.find((item) => item.name === 'TITLE')?.value,
    companyName: data?.setting.find((item) => item.name === 'COMPANY_NAME')?.value,
    customStyles: data?.setting.find((item) => item.name === 'CUSTOM_STYLE')?.value,
    supportPhone: data?.setting.find((item) => item.name === 'SUPPORT_PHONE')?.value,
    supportEmail: data?.setting.find((item) => item.name === 'SUPPORT_EMAIL')?.value,
    emailLoginEnabled: data?.setting.find((item) => item.name === 'EMAIL_LOGIN_ENABLED')?.value,
    samlLoginEnabled: data?.setting.find((item) => item.name === 'SAML_LOGIN_ENABLED')?.value,
    externalResourcesUrl: data?.setting.find((item) => item.name === 'EXTERNAL_RESOURCES_URL')?.value,
    platformSetupStatus: data?.setting.find((item) => item.name === 'PLATFORM_SETUP_STATUS')?.value,
    rt: {
      organismeName: data?.setting.find((item) => item.name === 'LEGAL_RT_ORGANISME_NAME')?.value,
      contactAddress: data?.setting.find((item) => item.name === 'LEGAL_RT_CONTACT_ADDRESS')?.value,
      dpoName: data?.setting.find((item) => item.name === 'LEGAL_RT_DPO_NAME')?.value,
      dpoEmail: data?.setting.find((item) => item.name === 'LEGAL_RT_DPO_EMAIL')?.value,
    },
    legalDocVersions: data?.legalDocVersions,
    setupNeedsFirstAdmin: data?.setupNeedsFirstAdmin ?? false,
  }
}

const useWhiteLabel = () => {
  const selectedProgramIdRef = selectGetSelectedProgramId(programsStore)

  const queryResult = useQuery({
    queryKey: [WHITE_LABEL_QUERY_KEY, { programId: selectedProgramIdRef }],
    queryFn: () => {
      const programId = selectedProgramIdRef.value
      return getWhiteLabelData(programId)
    },
  })

  const whiteLabelRef = computed(() => {
    const data = V1ToV2DataMiddleware(queryResult.data.value)
    if (!data.logo && data.logoSmall) {
      data.logo = data.logoSmall
    }
    return data
  })

  return {
    whiteLabelRef,
    isPendingRef: queryResult.isPending,
    isErrorRef: queryResult.isError,
  }
}

export default useWhiteLabel
